<template>
  <v-layout wrap>

    <v-flex xs12 md12 v-if="embedded">
      <v-checkbox
        class="mb-0"
        color="secondary"
        :label="fieldLabel"
        :disabled="readonly"
        v-model="value">
      </v-checkbox>
    </v-flex>

    <v-flex xs12 md6 v-else>
      <v-checkbox
        class="mb-0"
        color="secondary"
        :label="fieldLabel"
        :disabled="readonly"
        v-model="value">
      </v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from '@/helpers.js'

export default {
  name: 'check-box',
  props: {
    field: {
      type: Object
    },
    data: {
      type: Boolean
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  computed: {
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    value: {
      get() {
        let val = false
        if (this.data) {
          val = this.data
        } else {
          if (this.field.default_value) { val = this.field.default_value }
        }
        return val
      },
      set(newState) {
        this.$emit('update-item', { field: this.field.name, data: newState, row: this.row })
        this.$emit("blurred", {
          field: this.field.name,
          data: newState,
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  }
}
</script>
